<template>
  <div class="user-page">
    <el-row class="user-page__row">
      <p class="page-form-title">User page</p>
      <p class="page-form-tip">View user details.</p>
      <el-col>
        <div class="user-card__account-id">
          <el-tag type="primary" effect="dark"
            ><i class="el-icon-user-solid"></i> AccountId:
            {{ this.$route.params.name.match(/(\S*)@/)[1] }}</el-tag
          >
        </div>
      </el-col>
    </el-row>
    <el-row class="user-page__row">
      <el-card>
        <p class="title">Assets List</p>
        <el-table
          class="transaction-table"
          :data="stateUserAssets"
          v-if="stateUserAssets"
        >
          <el-table-column prop="assetId" label="AssetId">
            <template slot-scope="scope">
              {{ scope.row.assetId.match(/(\S*)#/)[1] }}
            </template>
          </el-table-column>
          <el-table-column prop="balance" label="Balance" />
        </el-table>
      </el-card>
    </el-row>
    <el-row class="user-page__row">
      <el-card>
        <p class="title">Transactions History</p>
        <el-table
          class="transaction-table"
          :data="transformed"
          v-if="transformed"
        >
          <el-table-column prop="from" label="From">
            <template slot-scope="scope">
              {{
                scope.row.from.includes('@')
                  ? scope.row.from.match(/(\S*)@/)[1]
                  : scope.row.from
              }}
            </template>
          </el-table-column>
          <el-table-column prop="to" label="To">
            <template slot-scope="scope">
              {{
                scope.row.to.includes('@')
                  ? scope.row.to.match(/(\S*)@/)[1]
                  : scope.row.to
              }}
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="Amount" />
          <el-table-column prop="currency" label="Currency">
            <template slot-scope="scope">
              {{ scope.row.currency.match(/(\S*)#/)[1] }}
            </template>
          </el-table-column>
          <el-table-column prop="message" label="Message" />
          <el-table-column prop="date" label="Date">
            <template slot-scope="scope">
              <span>{{ scope.row.date | formatDateLong }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { filters as dateFilters } from '@util/date-format'

export default {
  name: 'user-detail-page',

  data() {
    return {
      transformed: undefined
    }
  },

  filters: {
    ...dateFilters
  },

  methods: {
    ...mapActions(['getUserAccountAssets', 'getUserAccountAssetsTransactions']),
    formateTransactions(transactions) {
      let newArr = []
      transactions.map((i) => {
        newArr = [...newArr, ...i.transactionsList]
      })

      if (_.isEmpty(newArr)) return []

      newArr.sort((a, b) => {
        return (
          b.payload.reducedPayload.createdTime -
          a.payload.reducedPayload.createdTime
        )
      })

      const transformed = []

      newArr.forEach((t) => {
        const { commandsList, createdTime } = t.payload.reducedPayload

        commandsList.forEach((c) => {
          if (!c.transferAsset) return

          const {
            amount,
            assetId,
            destAccountId,
            srcAccountId,
            description
          } = c.transferAsset

          const tx = {
            from: srcAccountId,
            to: destAccountId,
            amount: amount,
            date: createdTime,
            currency: assetId,
            message: description
          }

          transformed.push(tx)
        })
      })
      return transformed
    }
  },

  computed: mapState({
    stateUserAssets: (state) => state.Account.userAssets,
    stateUserTransactions: (state) => state.Account.userTransactions
  }),

  mounted() {
    this.getUserAccountAssets({ accountId: `${this.$route.params.name}` })
      .then(() => {
        this.getUserAccountAssetsTransactions({
          assetIds: this.stateUserAssets,
          accountId: `${this.$route.params.name}`
        }).then(() => {
          this.transformed = this.formateTransactions(
            this.stateUserTransactions
          )
        })
      })
      .catch((err) => {
        this.$alert(err.message, 'ERROR', {
          type: 'error'
        })
      })
  }
}
</script>

<style scoped lang="scss">
.user-page__row {
  padding: 2rem;
  &:first-child {
    padding-bottom: 1rem;
  }
  .title {
    font-weight: bold;
    margin-bottom: 1rem;
  }
}

.user-page__user {
  .transaction-table {
    margin-bottom: 3rem;
  }
}
</style>
